import { THREADS_PANEL_SET_SHOWN } from '@storeOld/actions'
import { all, takeEvery } from 'redux-saga/effects'

import { artBoardActions } from '../actions'
import { jumpToPage } from './jumpToPage'
import { jumpToThread } from './jumpToThread'
import { leaveCommentModeOnPanelClose } from './leaveCommentMode'
import {
  closeOthersForStructure,
  closeStructureForMode,
} from './panelExclusivity'
import { revealSection } from './revealSection'
import { trackStructureOpen } from './trackStructureOpen'

export function* artboardSaga() {
  yield all([
    takeEvery(artBoardActions.jumpToThread, jumpToThread),
    takeEvery(artBoardActions.jumpToPage, jumpToPage),
    takeEvery(artBoardActions.revealSection, revealSection),
    takeEvery(artBoardActions.showStructure, closeOthersForStructure),
    takeEvery(artBoardActions.showStructure, trackStructureOpen),
    takeEvery(artBoardActions.changeMode, closeStructureForMode),
    takeEvery(THREADS_PANEL_SET_SHOWN, leaveCommentModeOnPanelClose),
  ])
}
